import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "../components/UI/Button";

export enum DialogPrompResult {
  YES,
  NO
}

export interface IDialogPrompt {
  open: boolean;
  caption: string;
  text: string;
  onClose: (changed: number) => void;
}

export function DialogPrompt(props: IDialogPrompt) {

  const onClose = async (action : number) => {
    props.onClose(action);
  };

  const onAbort = () => {
    props.onClose(DialogPrompResult.NO);
  }

  return (
    <Dialog onClose={onAbort} open={props.open} fullWidth>
      <DialogTitle className={`flex content-center justify-between`}>
        {props.caption}
        <IconButton onClick={onAbort}>
            <CloseIcon />
        </IconButton>
      </DialogTitle>
      <div className="px-6 pb-6 rounded-lg shadow-lg bg-white">
          <p className="text-gray-500 mb-5">{props.text}</p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-1 mt-6">
            <Button key="btn1" className="w-full" onClick={() => onClose(DialogPrompResult.YES)}>
              Ja
            </Button>
            <Button key="btn2" className="w-full bg-blue-400" onClick={() => onClose(DialogPrompResult.NO)}>
              Abbrechen
            </Button>
          </div>
      </div>
    </Dialog>
  );
}
